import { actions } from '@/store/module/membership/action/actions.js';
import { getters } from '@/store/module/membership/getter/getters.js';
import { mutations } from '@/store/module/membership/mutation/mutations.js';

export const membership = {
	namespaced: true,

	state: () => ({
		memberships: []
	}),

	actions,
	getters,
	mutations
};
